import store from "@/store";

import Index from "@/pages/albert/Index";
import Home from "@/pages/albert/Home";
import Introduction from "@/pages/albert/Introduction";
import Origin from "@/pages/albert/Origin";
import Past from "@/pages/albert/Past";
import Progress from "@/pages/albert/Progress";
import Future from "@/pages/albert/Future";

export default {
  path: "/albert",
  component: Index,
  beforeEnter(to, from, next) {
    store.dispatch("loadPage", "explore-albert-street").then(next);
  },
  meta: {
    label: "Albert Street",
    group: "Stations"
  },
  children: [
    {
      path: "",
      name: "Albert Street Home",
      component: Home,
      meta: {
        label: "Home",
        hide: true
      }
    },
    {
      path: "intro",
      name: "Albert Street Introduction",
      component: Introduction,
      meta: {
        label: "Introduction",
        showSidebar: true
      }
    },
    {
      path: "origin",
      name: "Albert Street Origin",
      component: Origin,
      meta: {
        child: true,
        label: "Origin"
      }
    },
    {
      path: "past",
      name: "Albert Street Past",
      component: Past,
      meta: {
        child: true,
        label: "Past"
      }
    },
    {
      path: "progress",
      name: "Albert Street Progress",
      component: Progress,
      meta: {
        child: true,
        label: "Progress"
      }
    },
    {
      path: "future",
      name: "Albert Street Future",
      component: Future,
      meta: {
        child: true,
        label: "Future"
      }
    }
  ]
};
